type Layer = {
  display: number;
  presentation: number;
  scene: number;
  background: number;
  fraction: number;
};

const Layers: Layer = {
  display: 2,
  presentation: 1,
  scene: 0,
  background: -0.5,
  fraction: 0.1,
};

export default Layers;
